module.exports = __webpack_public_path__ + "static/media/pipeten_active.ed942c75.jpg";